import { useEffect, useState } from "react";
import FormInfoBox from "./FormInfoBox";

const index = ({ profileData, servicesList }) => {
  useEffect(() => {}, [profileData, servicesList]);
  return (
    <div className="widget-content">
      <FormInfoBox proDetail={profileData} servicesList={servicesList} />
    </div>
  );
};

export default index;
